import React from 'react';
import HeaderSimplePage from 'Components/HeaderMobile/SimplePage';
import { customerServiceNumber, customerServiceNumberDial } from 'Utils/getCustomerServicePhone';

const Tag = () => {
  return (
    <>
      <HeaderSimplePage color="green" title="Künye" />

      <div className="page page--about">

        <img className='about__logo' src='/public/images/big-logo.png' alt="Bilyoner" />

        <div className='about__text text-500 text-center'>
          { new Date().getFullYear() } Bilyoner İnteraktif Hizmetler A.Ş.
          <br />
          Her Hakkı Saklıdır.
        </div>

        <div className='about__text text-500 text-center'>
          Bilyoner Müşteri Hizmetleri
          <br />
          <a title={ customerServiceNumber } className='about__text--soft' href={ customerServiceNumberDial }>{ customerServiceNumber }</a>
        </div>

        <div className='about__text text-500 text-center'>
          İnsan Kaynakları
          <br />
          <a title="kariyer@bilyoner.com " className='about__text--soft' href='mailto:kariyer@bilyoner.com'>kariyer@bilyoner.com </a>
        </div>

        <div className='about__text text-500 text-center'>
          Açık Adres
          <br />
          <span className='about__text--soft'>Eski Büyükdere Cad. Özcan Sok. Hitay Plaza No:2 <br />4 Levent/Kağıthane/İstanbul</span>
        </div>

        <div className='about__text text-500 text-center'>
          Mersis No
          <br />
          <span className='about__text--soft'>0608031494500011</span>
        </div>

        <div className='about__text text-500 text-center'>
          Kep Adresi
          <br />
          <a title="bilyoner@hs03.kep.tr" className='about__text--soft' href='mailto:bilyoner@hs03.kep.tr'>bilyoner@hs03.kep.tr</a>
        </div>


      </div>
    </>
  );
};

export default Tag;
